<template>
  <div
    class="tab-selection"
    data-sb-regression="sb-pill-selection"
  >
    <sb-chip
      v-for="option in selection"
      :key="option.id"
      dismissable
      @close="$emit('remove-pill', option)"
    >
      <sb-text :value="option.displayName" />
    </sb-chip>
  </div>
</template>

<script>
import SbChip from '@src/components/Chip/SbChip.vue';
import SbText from '@src/components/Text/SbText.vue';

export default {
  name: 'SbPillSelection',
  components: {
    SbChip,
    SbText,
  },
  props: {
    selection: {
      // array of {id: string | number, displayName: string}
      type: Array,
      default: () => ([]),
    },
  },
  emits: [
    /**
    * Emitted when dismissing option
    * @param {bool} value
    */
    'remove-pill',
  ],
};

</script>

<style lang="scss">
  .tab-selection {
    display: flex;
    flex-wrap: wrap;
    .sb-chip {
      margin-right: $space-ss;
      margin-bottom: $space-xs;
      padding-left: $space-ss;
      span,.sb-chip__dismiss  {
        font-weight: $weight-semi-bold;
        font-size: $size-m;
      }
    }
  }
</style>
